import { render, staticRenderFns } from "./admMuestra-solicitante.vue?vue&type=template&id=24c10042&"
import script from "./admMuestra-solicitante.vue?vue&type=script&lang=js&"
export * from "./admMuestra-solicitante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports